import { useState } from "react";
import { PageHero, Reveal } from "@/components/bits/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ_BUSINESS, FAQ_EMPLOYERS, FAQ_STUDENTS, FAQ_COLLEGES } from "@/data/faqs";
import { IMAGES } from "@/data/content";
import { useSEO } from "@/lib/seo";

const TABS = [
  { key: "business", label: "About Maqline", faqs: FAQ_BUSINESS, testId: "faq-tab-business" },
  { key: "employers", label: "For Employers", faqs: FAQ_EMPLOYERS, testId: "faq-tab-employers" },
  { key: "students", label: "For Students", faqs: FAQ_STUDENTS, testId: "faq-tab-students" },
  { key: "colleges", label: "For Colleges", faqs: FAQ_COLLEGES, testId: "faq-tab-colleges" },
];

export default function Faq() {
  useSEO(
    "FAQs | Maqline Solutions Pvt Ltd — Manpower, Jobs, Internships & Partnerships",
    "Answers about Maqline Solutions Pvt Ltd — manpower outsourcing, recruitment process, job openings, internships, industrial training and college partnerships."
  );
  const [tab, setTab] = useState("business");
  const active = TABS.find((t) => t.key === tab);

  return (
    <main data-testid="faq-page">
      <PageHero
        overline="Frequently Asked Questions"
        titleLines={["Clear answers.", "No fine print."]}
        description="Everything businesses, students and colleges usually ask us — answered directly."
        image={IMAGES.factory}
      />

      <section className="bg-steel py-16 sm:py-24">
        <div className="max-w-4xl mx-auto px-5 sm:px-8">
          <Reveal>
            <div className="flex flex-wrap gap-2 mb-10" data-testid="faq-tabs">
              {TABS.map((t) => (
                <button
                  key={t.key}
                  data-testid={t.testId}
                  onClick={() => setTab(t.key)}
                  className={`text-xs sm:text-sm font-bold uppercase tracking-[0.12em] px-5 py-3 rounded-sm border transition-all duration-300 ${
                    tab === t.key
                      ? "bg-gold text-darknavy border-gold"
                      : "bg-white text-ink/60 border-ink/15 hover:border-gold hover:text-gold"
                  }`}
                >
                  {t.label}
                </button>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="space-y-3" data-testid={`faq-list-${tab}`}>
              {active.faqs.map((f, i) => (
                <AccordionItem key={`${tab}-${i}`} value={`${tab}-${i}`} className="bg-white border border-ink/8 rounded-sm px-6 data-[state=open]:border-gold/50 transition-colors duration-300" data-testid={`faq-item-${tab}-${i}`}>
                  <AccordionTrigger className="text-left font-display text-base sm:text-lg text-ink hover:no-underline py-5">{f.q}</AccordionTrigger>
                  <AccordionContent className="text-sm text-muted leading-relaxed pb-5">{f.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>

          <Reveal delay={0.15}>
            <p className="text-center text-sm text-muted mt-12">
              Still have a question? Email us at <a href="mailto:info@maqlinesolutions.com" className="text-navy font-semibold hover:text-gold transition-colors">info@maqlinesolutions.com</a> and our team will respond shortly.
            </p>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
